<script setup lang="ts">
import { Button } from '@/components/ui/button';

defineProps({
  tab: {
    type: String as PropType<'video' | 'details'>,
    required: true,
  },
  /** Show a close button instead of the search shortcut (preview sheet). */
  closable: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{
  'update:tab': [value: 'video' | 'details'],
  close: [],
}>();

</script>

<template>
  <header class="feed-top-bar pointer-events-none absolute inset-x-6 top-[max(1.5rem,env(safe-area-inset-top,0px))] z-40 grid grid-cols-[2.5rem_1fr_2.5rem] items-start">
    <!-- Optional control on the left, e.g. «Назад» on a listing page. -->
    <div v-if="$slots.leading" class="pointer-events-auto col-start-1 row-start-1">
      <slot name="leading" />
    </div>
    <div
      class="pointer-events-auto col-start-2 row-start-1 flex items-start justify-center gap-5 justify-self-center"
      aria-label="Режим просмотра"
      role="group"
    >
      <Button
        type="button"
        variant="ghost"
        size="sm"
        :aria-pressed="tab === 'video'"
        class="feed-top-bar__tab h-auto rounded-none border-b-2 border-transparent bg-transparent px-0.5 pb-2.5 pt-1 text-[0.9375rem] font-bold leading-none text-white hover:bg-transparent hover:text-white"
        :class="{ 'feed-top-bar__tab--active': tab === 'video' }"
        @click="emit('update:tab', 'video')"
      >
        Видео
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        :aria-pressed="tab === 'details'"
        class="feed-top-bar__tab h-auto rounded-none border-b-2 border-transparent bg-transparent px-0.5 pb-2.5 pt-1 text-[0.9375rem] font-bold leading-none text-white hover:bg-transparent hover:text-white"
        :class="{ 'feed-top-bar__tab--active': tab === 'details' }"
        @click="emit('update:tab', 'details')"
      >
        Детали
      </Button>
    </div>

    <Button
      v-if="closable"
      type="button"
      variant="ghost"
      size="icon-lg"
      class="pointer-events-auto col-start-3 row-start-1 size-10 justify-self-end rounded-full border border-white/25 bg-black/30 text-white backdrop-blur-sm hover:bg-black/40 hover:text-white"
      aria-label="Закрыть"
      @click="emit('close')"
    >
      <Icon
        name="tabler:x"
        class="size-6"
        aria-hidden="true"
      />
    </Button>
    <Button
      v-else
      as-child
      type="button"
      variant="ghost"
      size="icon-lg"
      class="feed-top-bar__search pointer-events-auto col-start-3 row-start-1 size-10 justify-self-end rounded-full border border-muted-foreground/30! bg-white! shadow-none hover:bg-white!"
    >
      <NuxtLink
        to="/search"
        aria-label="Поиск"
      >
        <Icon
          name="tabler:search"
          class="size-6"
          aria-hidden="true"
        />
      </NuxtLink>
    </Button>
  </header>
</template>

<style scoped>
.feed-top-bar__tab {
  border-top-width: 0 !important;
  border-right-width: 0 !important;
  border-left-width: 0 !important;
}

.feed-top-bar__tab:focus-visible {
  border-color: transparent !important;
  box-shadow: none !important;
}

.feed-top-bar__tab--active,
.feed-top-bar__tab--active:focus-visible {
  border-bottom-color: #fff !important;
}

.feed-top-bar__search {
  color: var(--muted-foreground) !important;
}
</style>
